import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCatalogProductDetails = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/productdetails" */
      '.'
    ),
);
